import Endpoint from "constants/endpoint";
import axiosInstance from "./service-instance";

const createFacility = (case_id, data) =>
    axiosInstance.put(`/case/${case_id}/post-compliance/`, data, {
        headers: {
            "Content-Type": "application/json"
        }
    });

const getFacility = (case_id, data) =>
    axiosInstance.get(`/case/${case_id}/post-compliance/`, data, {
        headers: {
            "Content-Type": "application/json"
        }
    });

const getSupplyChainList = (case_id) =>
    axiosInstance.get(`/case/${case_id}/distinct-supply-chain/`, {
        headers: {
            "Content-Type": "application/json"
        }
    });

const updateSupplyChains = (case_id, data) =>
    axiosInstance.post(`/company/${case_id}/supplychain/scheme/update/`, data, {
        headers: {
            "Content-Type": "application/json"
        }
    });

const SchemeDetailsList = (code, sellerId) =>
    axiosInstance.get("/scheme/detail/list/", {
        params: {
            code,
            seller_id: sellerId
        },
        headers: {
            "Content-Type": "application/json"
        }
    });
const addUTR = (data) => 
    axiosInstance.post("/case/create-transaction/", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });

const SubmitFinYearId = (data, case_id) =>
    axiosInstance.post(`/case/${case_id}/financial-detail-year/update/`, data, {
        headers: {
            "Content-Type": "application/json"
        }
    });

const getEmiInstanceValues = (caseID) => 
    axiosInstance.get(`case/${caseID}/bnpl/prefetch/`, {
        headers: {
            "Content-Type": "application/json"
        }
    });

const getBNPLlisting = (caseID) => 
    axiosInstance.get(`case/${caseID}/bnpl/listing/`, {
        headers: {
            "Content-Type": "application/json"
        }
    });

const getBNPLlistingV2 = (caseID) => 
    axiosInstance.get(`case/${caseID}/bnpl/aggregate-emi-schedule/`, {
        headers: {
            "Content-Type": "application/json"
        }
    });

    

const getGenerateScehduleBNPL = (caseID, data, disbursal_date , emiType , add_fees_to_first_tranche , first_instalment_deducted_from_disbursal , moratoriumDays) => {
    return (
        axiosInstance.get(`case/${caseID}/bnpl/emi/schedule/?principal=${data?.principal}&tenure=${data?.tenure}&tentative_disbursal_date=${disbursal_date}&emi_type=${emiType}&add_fees_to_first_tranche=${add_fees_to_first_tranche}&is_first_instalment_deducted_from_disbursal=${first_instalment_deducted_from_disbursal}&moratorium_days=${moratoriumDays}`))};

const getScheduleOfChargesBNPL = (caseID) => {
    return(
        axiosInstance.get(`case/${caseID}/bnpl/charge/schedule/`)
    );};

const postEmiInstance = (caseID, data) => {
    return(
        axiosInstance.post(`case/${caseID}/bnpl/emi/schedule/`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        })
    );}

const resetEmiSchedule = (caseID) => {
        return(
            axiosInstance.post(Endpoint.resetSchedule.replace(":case_id" , caseID), {} ,{
                headers: {
                    "Content-Type": "application/json"
                }
            })
        );}

const saveScehduleBNPL = (caseID, data, principal) => {
    let payload = {
        "principal" : principal,
        "tenure": data?.tenure,
        "tentative_disbursal_date": data.from_date.format('YYYY-MM-DD'),
        "emi_type": data.emiType,
        'is_first_instalment_deducted_from_disbursal': data.is_first_instalment_deducted_from_disbursal,
        'moratorium_days': data.moratorium_days,
    }    
    return  axiosInstance.post(`/case/${caseID}/bnpl/emi/schedule/save/`, payload, {
        headers: {
            "Content-Type": "application/json"
        }
    });
}

const getSavedSchedule = (caseID) => {
    return(
        axiosInstance.get(`case/${caseID}/bnpl/emi/schedule/save/`)
    );};


        

export default {
    createFacility,
    getFacility,
    getSupplyChainList,
    updateSupplyChains,
    SchemeDetailsList,
    addUTR,
    SubmitFinYearId,
    getEmiInstanceValues,
    getGenerateScehduleBNPL,
    postEmiInstance,
    getScheduleOfChargesBNPL,
    getBNPLlisting,
    getBNPLlistingV2,
    resetEmiSchedule,
    saveScehduleBNPL,
    getSavedSchedule
};

